import { render, staticRenderFns } from "./SectorCompaniesModalContent.vue?vue&type=template&id=aae0148c&"
import script from "./SectorCompaniesModalContent.vue?vue&type=script&lang=js&"
export * from "./SectorCompaniesModalContent.vue?vue&type=script&lang=js&"
import style0 from "./SectorCompaniesModalContent.vue?vue&type=style&index=0&id=aae0148c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports